import React from 'react'
import { useSelector } from 'react-redux'
import { SvgIcon } from '@mui/material'
import { FmdGoodOutlined, LightbulbCircleOutlined, LightbulbOutlined } from '@mui/icons-material'
import { ratingIcons } from 'keys/rating'

const naLabel = 'א/נ'

// רמת ההתערבות הנדרשת לפי דירוג (מהעיצוב) — עבור 3 הדירוגים הנמוכים
const interventionByTier = {
    3: 'עבודה על שטף הקריאה תוך הקפדה על דיוק',
    4: 'ביסוס של יסודות הקריאה ועבודה על שטף',
    5: 'רכישה של יסודות הקריאה',
}

// תוכניות ההתערבות — הנתונים יגיעו בשלב ב' (א/נ בינתיים)
const interventionPrograms = ['עירוני', 'ניצן', 'שילוב']

// עמוד "הצעדים הבאים לצמצום פערים" — צרכים ומענים
const Slide6Interventions = ({ data, interventionData = {} }) => {
    const { brokenDisplay } = useSelector(state => state.general)
    const { strugglingTiers, needsCount } = data

    return (
        <div className='steps-layout'>
            <div className='info-callout'>
                <SvgIcon component={LightbulbOutlined} className='callout-icon' />
                <div>
                    {'תלמיד המתקשה בקריאה זקוק '}
                    <b>{'להתאמת למידה בכיתה'}</b>
                    {' כדי לעמוד בקצב '}
                    <b>{'ולהתערבות לקידום הקריאה'}</b>
                    {' כדי לצמצם את הפערים ולהגיע לרמת בני גילו.'}
                </div>
            </div>

            <div className='numbered-section'>
                <div className='numbered-section-header'>
                    <div className='section-number'>{'01'}</div>
                    <div className='section-title'>{'צמצום פערים בקריאה - צרכים'}</div>
                    {needsCount > 0 &&
                        <div className={`section-total`}><span className={`${brokenDisplay && 'blurred2'}`}>{needsCount.toLocaleString()}</span>{` תלמידים`}</div>}
                </div>
                <div className='slide-subtitle'>
                    {'לתלמידים בדירוגים השונים יש צרכים שונים של התערבות לקידום הקריאה עד לטווח המצופה'}
                </div>
                <div className='tier-needs-cards'>
                    {strugglingTiers?.map(tier => (
                        <div key={tier.index} className='tier-needs-card' style={{ backgroundColor: `${tier.cardBgColor}` }}>
                            <div className='tier-needs-header'>
                                <span className='tier-chip' style={{ backgroundColor: tier.labelBg, color: tier.textColor, fontWeight: 400 }}>
                                    <i className={ratingIcons[tier.index - 1]} />
                                    {tier.label}
                                </span>
                                <span className={``} style={{ color: tier.textColor }}><span className={`${brokenDisplay && 'blurred2'}`}>{tier.count.toLocaleString()}</span>{` תלמידים`}</span>
                            </div>
                            <div>
                                <b>{'רמת התערבות:'}</b>
                                <div>{interventionByTier[tier.index]}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='numbered-section'>
                <div className='numbered-section-header'>
                    <div className='section-number'>{'02'}</div>
                    <div className='section-title'>{'צמצום פערים בקריאה - מענים'}</div>
                    {/* סה"כ תלמידים המקבלים מענה */}
                    {(() => {
                        const totalAnswered = interventionData?.tiers
                            ? Object.values(interventionData.tiers).reduce((sum, tierData) => sum + (tierData?.total || 0), 0)
                            : 0
                        return (
                            <div className={`section-total ${totalAnswered > 0 && brokenDisplay && 'blurred2'}`}>
                                {totalAnswered > 0 ? totalAnswered.toLocaleString() : naLabel}
                            </div>
                        )
                    })()}
                </div>
                <div className='tier-needs-cards'>
                    {strugglingTiers?.map(tier => {
                        const tierData = interventionData?.tiers?.[tier.index.toString()] || {}
                        const tierTotal = tierData?.total || 0

                        return (
                            <div key={tier.index} className='tier-needs-card split-card'>
                                {/* כמו בפיגמה: רק הכותרת צבועה, גוף הכרטיס לבן */}
                                <div className='tier-needs-header' style={{ backgroundColor: tier.cardBgColor }}>
                                    <span className='tier-chip' style={{ backgroundColor: tier.labelBg, color: tier.textColor, fontWeight: 400 }}>
                                        <i className={ratingIcons[tier.index - 1]} />
                                        {tier.label}
                                    </span>
                                    {/* כמות התלמידים המקבלים מענה */}
                                    <span className={`${tierTotal > 0 && brokenDisplay && 'blurred2'}`} style={{ color: tier.textColor }}>{tierTotal > 0 ? tierTotal.toLocaleString() : naLabel}</span>
                                </div>
                                <div className='program-boxes'>
                                    {interventionPrograms.map(program => {
                                        const programCount = tierData?.programs?.[program] || 0
                                        return (
                                            <div key={program} className='program-box'>
                                                <div className='program-name'>{program}</div>
                                                {/* כמות תלמידים בתוכנית */}
                                                <div className={`program-value ${programCount > 0 && brokenDisplay && 'blurred2'}`}>{programCount > 0 ? programCount.toLocaleString() : naLabel}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Slide6Interventions
